import { render, staticRenderFns } from "./centralapoioNotasVersao.vue?vue&type=template&id=4246720e"
import script from "./centralapoioNotasVersao.vue?vue&type=script&lang=js"
export * from "./centralapoioNotasVersao.vue?vue&type=script&lang=js"
import style0 from "./centralapoioNotasVersao.vue?vue&type=style&index=0&id=4246720e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports